import Vue from 'vue'
import ActionCableVue from 'actioncable-vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VCalendar from 'v-calendar'
import VueCookies from 'vue-cookies'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import { library } from '@fortawesome/fontawesome-svg-core'
import 'vue-good-table/dist/vue-good-table.css'
import Loading from '@/components/Loading'
import vueCountryRegionSelect from 'vue-country-region-select'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VueClipboard from 'vue-clipboard2'
import i18n from './internatinalization/i18n'
import VTooltip from 'v-tooltip'
import { VPopover } from 'v-tooltip'
import JsonCSV from 'vue-json-csv'
export const bus = new Vue()
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import Vuelidate from 'vuelidate'
import './plugins/gtm'
import Hotjar from 'vue-hotjar'
import './plugins/element-ui'

// window.onerror = async function(message, source, lineno, colno, error) {
//   const errorDetails = {
//     message,
//     source,
//     lineno,
//     colno,
//     error
//   }
//   await reportToSlack(errorDetails)
//   return true
// }

// Vue.config.errorHandler = async function(err, vm, info) {
//   await reportToSlack({ err, vm, info })
// }

// window.onunhandledrejection = async function(event) {
//   await reportToSlack(event.reason)
//   return true
// }

Vue.use(Vuelidate)
Vue.use(Notifications, { velocity })
Vue.use(VCalendar)
Vue.use(VueCookies)
Vue.use(vueCountryRegionSelect)
Vue.use(VueClipboard)
Vue.use(VTooltip)
Vue.use(VueTelInput, {
  mode: 'international',
  validCharactersOnly: true,
  inputOptions: {
    autocomplete: 'off',
    placeholder: ''
  }
})

Vue.use(Hotjar, {
  id: '2898303',
  isProduction: process.env.VUE_APP_NODE_ENV.toLowerCase() === 'production'
})

Vue.filter('splitUID', value => {
  return value.split('-')[0].toUpperCase()
})

Vue.filter('Capitalize', value => {
  if (value) {
    let cleanText = value.replace('_', ' ')
    return cleanText.charAt(0).toUpperCase() + cleanText.slice(1)
  }
})

Vue.filter('formatCurrency', value => {
  let val = (value / 1).toFixed(2).replace('.', '.')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('formatNumber', value => {
  if (value) {
    return value
      .toString()
      .replace(/\D/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return 0
})

VueCookies.config('14d')

import {
  faCalendarAlt,
  faChevronDown,
  faWallet,
  faUserTie,
  faPlug,
  faUsers,
  faTruck,
  faChartLine
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { reportToSlack } from '@/utils/slack-error-reporter'

library.add(
  faCalendarAlt,
  faChevronDown,
  faWallet,
  faUserTie,
  faPlug,
  faUsers,
  faTruck,
  faChartLine
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('Loading', Loading)
Vue.component('v-select', vSelect)
Vue.component('downloadCsv', JsonCSV)
Vue.component('v-popover', VPopover)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

const auth = store.getters['auth/auth']
Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'error',
  connectionUrl: `${process.env.VUE_APP_WS_URL}/cable?access-token=${auth['access-token']}&uid=${auth['uid']}&client=${auth['client']}`, // or function which returns a string with your JWT appended to your server URL as a query parameter
  connectImmediately: true
})
